import {SODeletePrice} from '../../core/price/so-delete-price';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeletePrice extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeletePrice;
}